export default "__VITE_ASSET__yrVDGu46__"